// extracted by mini-css-extract-plugin
module.exports = {"root":"root-DaVfl","arrowBackIcon":"arrowBackIcon-Y2QAQ","arrowBackText":"arrowBackText-2zAfA"};